import { ButtonDropdownActionsModel, NavBarBtnModel } from 'common/src/models';
import { DataImportEntityEnum } from '../../models';

export const COMMON_PROPS: NavBarBtnModel = {
  classes: 'btn-white',
  text: 'DATA_IMPORT.DOWNLOAD_TEMPLATE',
  iconName: 'file-xlsx',
  allowLoadingSpinner: true,
  disabledMainAction: true,
  disabled: false,
  actionName: 'downloadTemplate',
}

export const PRODUCTS_ACTIONS: ButtonDropdownActionsModel[] = [
  {
    actionTitle: 'COMMON.GOODS',
    actionName: 'downloadTemplate',
    actionIcon: 'file-xlsx',
    returnValue: DataImportEntityEnum.GOODS
  },
  {
    actionTitle: 'APP.SERVICES',
    actionName: 'downloadTemplate',
    actionIcon: 'file-xlsx',
    returnValue: DataImportEntityEnum.SERVICES
  },
  {
    actionTitle: 'APP.DIGITAL_PRODUCTS',
    actionName: 'downloadTemplate',
    actionIcon: 'file-xlsx',
    returnValue: DataImportEntityEnum.DIGITAL_PRODUCTS
  },
];

export const PARTNERS_ACTIONS: ButtonDropdownActionsModel[] = [
  {
    actionTitle: 'APP.CORPORATE_PARTNERS_1',
    actionName: 'downloadTemplate',
    actionIcon: 'file-xlsx',
    returnValue: DataImportEntityEnum.CORPORATE_PARTNERS
  },
  {
    actionTitle: 'APP.PRIVATE_PARTNERS',
    actionName: 'downloadTemplate',
    actionIcon: 'file-xlsx',
    returnValue: DataImportEntityEnum.PRIVATE_PARTNERS
  },
]

export const DATA_IMPORT_NAVBAR_BUTTONS: NavBarBtnModel[] = [
  {
    classes: 'btn-white',
    text: 'DATA_IMPORT.DOWNLOAD_TEMPLATE',
    iconName: 'file-xlsx',
    allowLoadingSpinner: true,
    disabledMainAction: true,
    disabled: false,
    actionName: 'downloadTemplate',
    actions: [
      ...PRODUCTS_ACTIONS,
      ...PARTNERS_ACTIONS,
      {
        actionTitle: 'APP.PRICES',
        actionName: 'downloadTemplate',
        actionIcon: 'file-xlsx',
        returnValue: DataImportEntityEnum.PRICES
      },
      {
        actionTitle: 'APP.STOCK_STATUS',
        actionName: 'downloadTemplate',
        actionIcon: 'file-xlsx',
        returnValue: DataImportEntityEnum.STOCK_STATUS
      },
      {
        actionTitle: 'APP.PAYMENTS',
        actionName: 'downloadTemplate',
        actionIcon: 'file-xlsx',
        returnValue: DataImportEntityEnum.PAYMENTS
      },
      {
        actionTitle: 'COMMON.BP_ACCOUNTS',
        actionName: 'downloadTemplate',
        actionIcon: 'file-xlsx',
        returnValue: DataImportEntityEnum.PARTNER_ACCOUNT
      }
    ]
  },
];

export const DATA_IMPORT_PRODUCTS_NAVBAR_BUTTONS: NavBarBtnModel[] = [
  {
    ...COMMON_PROPS,
    actions: [
      ...PRODUCTS_ACTIONS,
    ]
  },
];

export const DATA_IMPORT_PARTNERS_NAVBAR_BUTTONS: NavBarBtnModel[] = [
  {
    ...COMMON_PROPS,
    actions: [
      ...PARTNERS_ACTIONS,
    ]
  },
];
